import { useMemo } from 'react'

import { Box } from '@material-ui/core'
import { ErrorBoundary } from '@scoir/error-reporter'

import AcademicFocus, { TSelectedValue } from 'components/AcademicFocusSelector'
import { getSegmentValue } from 'components/SegmentSelector/segment-service'
import { withContext } from './Context'

export const SegmentName = 'AcademicFocus'

export interface IAcademicFocusSelector {
  criteria?: string
  segment: any
  onChange: (criteria: string, segmentName: string, value: string[]) => void
}

export const AcademicFocusSelector = ({ criteria = 'OneOf', segment, onChange }: IAcademicFocusSelector) => {
  const currentValue = useMemo(() => getSegmentValue(segment, criteria, SegmentName), [segment, criteria])
  return (
      <ErrorBoundary>
        <Box
          pt={1}
          position="relative"
        >
          <AcademicFocus
            selectedFoci={currentValue}
            onSelect={(selectedValue: TSelectedValue) => {
              const value = selectedValue.AcademicFocus || []
              onChange(criteria, SegmentName, value)
            }}
            focusOnly
          />
        </Box>
      </ErrorBoundary>
  )
}

const AcademicFocusSelectorWithContext = withContext(AcademicFocusSelector)

export default AcademicFocusSelectorWithContext
